import { pnlAxisLabelStyle, pnlSecondaryLabelStyle } from 'src/components/star-grid/utils/pnlAxisPresentation';
import { ColDef, GridApi } from 'ag-grid-community';
import { PNL_SECONDARY_LINE_DIMENSION, PNL_STATEMENT_LINE_DIMENSION } from 'src/components/star-grid/starGridConstants';
import { PnlGridRow, PnlPivotModel } from 'src/components/star-grid/starGridTypes';

export const PNL_LABEL_WIDTH = 260;
export const PNL_LABEL_MIN_WIDTH = 160;

/** Returned statement lines include subtotals. Render them flat without client aggregation. */
export const isStatementModel = (model: PnlPivotModel): boolean => model.isFlatAxis ?? model.dimensionFields.includes(PNL_STATEMENT_LINE_DIMENSION);

export const statementDimensionColumns = (
  model: PnlPivotModel,
  labels?: Readonly<Record<string, string>>,
  preserveWidth = false
): ColDef<PnlGridRow>[] =>
  model.dimensionFields.map((field) => ({
    field,
    headerName: labels?.[field] ?? model.dimensionHeaders?.[field] ?? field,
    pinned: 'left',
    initialWidth: PNL_LABEL_WIDTH,
    width: preserveWidth ? undefined : PNL_LABEL_WIDTH,
    minWidth: PNL_LABEL_MIN_WIDTH,
    headerComponent: 'pnlHierarchyHeader',
    headerClass: 'sg-report-hierarchy-header',
    // The second identifying column takes only its own depth; bold belongs to the first.
    cellStyle: field === PNL_SECONDARY_LINE_DIMENSION ? pnlSecondaryLabelStyle : pnlAxisLabelStyle,
    // Named so presentation can target the LABEL cell (the section-title marker) without relying on
    // it being the first cell, which differs between the pinned and centre containers.
    cellClass: 'sg-report-line-label',
    sortable: false,
    valueGetter: ({ data }) => {
      if (field === PNL_SECONDARY_LINE_DIMENSION) return data?.[field];
      if (data?.axis_outer_repeat === true) return '';
      return model.isResolvedAxis || field === PNL_STATEMENT_LINE_DIMENSION ? data?.label ?? data?.[field] : data?.[field];
    }
  }));

export const togglePnlColumns = (api?: GridApi<PnlGridRow>): void => {
  if (!api) return;
  if (api.isToolPanelShowing()) {
    api.closeToolPanel();
    api.setSideBarVisible(false);
  } else {
    api.setSideBarVisible(true);
    api.openToolPanel('columns');
  }
};
